<template>
  <section v-if="video || (media && media.length)" ref="mediaRef" class="container">
    <div class="px-4 xl:px-0 text-xl lg:text-4xl font-bold mb-3 lg:mb-5 font-sf-pro text-gray-900">
      Медиа
    </div>
    <div class="px-4 xl:px-0 hidden lg:block">
      <div class="grid grid-cols-4 gap-7 transition-all duration-300 overflow-hidden">
        <div v-if="video" class="rounded-[17px] overflow-hidden h-42 relative">
          <a data-fancybox="gallery-activity" :href="rewriteImageUrl(video.image.uploadURL)">
            <t-icon-play
              class="absolute h-15 w-15 cursor-pointer z-100 left-0 right-0 bottom-0 top-0 m-auto"
            />
            <img
              class="object-cover w-full h-full cursor-pointer text-xl"
              loading="lazy"
              :data-blink-src="videoStub ? rewriteImageUrl(videoStub.uploadURL) : ImageEventDefault"
            />
          </a>
        </div>

        <div
          v-for="(photo, idx) in showMedia"
          :key="idx"
          class="rounded-[17px] overflow-hidden h-42"
        >
          <img
            data-fancybox="gallery-activity"
            :href="rewriteImageUrl(photo.image.uploadURL)"
            class="object-cover w-full h-full cursor-pointer text-xl"
            :data-caption="photo[idx]"
            loading="lazy"
            :data-blink-src="rewriteImageUrl(photo.image.uploadURL)"
          />
        </div>
        <!-- for fancybox -->
        <div v-for="(photo, idx) in lastMedia" :key="idx" class="hidden">
          <img
            data-fancybox="gallery-activity"
            :href="rewriteImageUrl(photo.image.uploadURL)"
            class="object-cover w-full h-full cursor-pointer text-xl"
            :data-caption="photo[idx]"
            loading="lazy"
            :data-blink-src="rewriteImageUrl(photo.image.uploadURL)"
          />
        </div>
      </div>
      <div
        v-if="
          ((video && mediateca.length > 3) || mediateca.length > 4) &&
          length >= mediateca.length &&
          length >= showMedia.length
        "
        class="w-fit mx-auto font-sf-pro text-base cursor-pointer text-primary-100 pt-6 text-center"
        @click="hideList()"
      >
        Скрыть
      </div>
      <div
        v-else-if="mediateca.length > 4 || (video && mediateca.length > 3)"
        class="w-fit mx-auto font-sf-pro text-base cursor-pointer text-primary-100 pt-6 text-center"
        @click="showMore()"
      >
        Показать еще
      </div>
    </div>
    <div class="lg:hidden block h-43">
      <div class="mySwiper px-4 xl:px-0 overflow-hidden">
        <div class="swiper-wrapper">
          <div
            v-if="!!video"
            class="rounded-[17px] !h-42 swiper-slide relative overflow-hidden"
            style=""
          >
            <a data-fancybox="gallery-mobile-activity" :href="rewriteImageUrl(video.image.uploadURL)">
              <t-icon-play
                class="absolute h-15 w-15 cursor-pointer z-100 left-0 right-0 bottom-0 top-0 m-auto"
              />
              <img
                class="object-cover w-full h-full cursor-pointer text-xl"
                loading="lazy"
                :data-blink-src="videoStub ? rewriteImageUrl(videoStub.uploadURL) : ImageEventDefault"
              />
            </a>
          </div>
          <div
            v-for="(photo, idx) in mediateca"
            :key="idx"
            class="rounded-[17px] overflow-hidden !h-42 swiper-slide"
          >
            <img
              data-fancybox="gallery-mobile-activity"
              :href="rewriteImageUrl(photo.image.uploadURL)"
              class="object-cover w-full h-full cursor-pointer text-xl"
              :data-caption="photo[idx]"
              loading="lazy"
              :data-blink-src="rewriteImageUrl(photo.image.uploadURL)"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import * as fancybox from '@fancyapps/ui'
import { Swiper, Pagination } from 'swiper'
import ImageEventDefault from '@/assets/svgs/imageEventDefault.svg'
import '@fancyapps/ui/dist/fancybox.css'
import 'swiper/css/bundle'
import rewriteImageUrl from '~/utils/rewrite-image-url'

Swiper.use([Pagination])

const { Fancybox } = fancybox

onMounted(() => {
  const _swiper = new Swiper('.mySwiper', {
    freeMode: true,
    spaceBetween: 12,
    // loop: true,
    slidesPerView: 1.5,
    breakpoints: {
      320: {
        slidesPerView: 1.5
        // allowTouchMove: false
      },
      450: {
        slidesPerView: 2
      },
      640: {
        slidesPerView: 3
      },
      860: {
        slidesPerView: 3.5
      }
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })

  Fancybox.bind("[data-fancybox='gallery']", {
    Image: {
      zoom: false,
      wheel: 'slide',
      hideScrollbar: false
    }
  })

  return {
    _swiper
  }
})

const props = defineProps({
  media: { type: Array, default: () => [] },
  videoStub: { type: Object, default: () => null },
  video: { type: Object, default: () => null }
})

const mediateca = ref(props.media)

const length = ref(4)

if (props.video) {
  length.value = 3
}

const showMedia = computed(() => mediateca.value.slice(0, length.value))

const lastMedia = computed(() => mediateca.value.slice(length.value))

function showMore() {
  if (length.value > showMedia.value.length) {
    return
  }
  length.value = length.value + 4
}

// @ts-ignore
const mediaRef = ref<HTMLElement>(null)

function hideList() {
  if (props.video) {
    length.value = 3
  } else {
    length.value = 4
  }

  mediaRef.value.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
}
</script>
